import React, { MouseEvent, useCallback, useState } from 'react';
import { CreateModal } from '@src/components/Atoms/Modal';

interface Props {
  width?: number;
  height?: number;
  onClose: () => void;
  stopPropagation?: (e: any) => void;
  backgroundColor?: string;
  children: React.ReactNode;
  borderRadius?: string;
}
const ModalContainer: React.FC<Props> = ({
  width,
  height,
  onClose,
  stopPropagation,
  children,
  backgroundColor,
  borderRadius,
}) => {
  const [target, setTarget] = useState<EventTarget>();

  const onSaveCurrentTarget = useCallback((event: MouseEvent) => {
    if (event.target) {
      setTarget(event.target);
    }
  }, []);

  return (
    <CreateModal
      onClick={(e) => {
        e.stopPropagation();
        if (target === e.currentTarget) {
          onClose();
        }
      }}
      width={width}
      height={height}
      backgroundColor={backgroundColor}
      borderRadius={borderRadius}
      onMouseDown={onSaveCurrentTarget}
    >
      <div
        onClick={stopPropagation}
        onMouseDown={onSaveCurrentTarget}
        onMouseUp={onSaveCurrentTarget}
      >
        {children}
      </div>
    </CreateModal>
  );
};

export default ModalContainer;
